export default __webpack_public_path__ + "static/media/Ar.69cf3c38.svg";